<template>
	<div class="usermana">
		<!-- 表头 -->
		<div class="button-group">
			<!-- 新建用户 -->
			<el-button type="primary" @click="createDialogVisible = true">新建</el-button>
			<!-- 刷新表单 -->
			<el-button type="success" @click="fetchUserList">刷新</el-button>
			<!-- 引入表单 -->
			<el-button type="primary" @click="triggerFileInput">导入</el-button>
			<!-- <input type="file" ref="fileInput" @change="importUser" accept=".csv" style="display: none" /> -->
			<input ref="fileInput" type="file" accept=".xlsx, .xls" style="display: none" @change="handleFileChange" />
			<!-- 删除选中用户 -->
			<el-button type="danger" :disabled="batchRemoveDisabled" @click="batchRemoveConfirm">删除选中</el-button>

			<div class="search">
				<el-input v-model="filterUser.id" size="large" style="width: 130px;" placeholder="学号"
					@change="fetchUserList" />
				<el-input v-model="filterUser.name" size="large" style="width: 130px;" placeholder="姓名"
					@change="fetchUserList" />
			</div>
		</div>

		<!-- 表单 -->
		<el-config-provider :locale="zhCn">
			<el-table :row-class-name="rowClassName" ref="multipleTableRef" :data="userList" highlight-current-row
				style="width: 100%; margin-top: 2vh; margin-bottom: 2vh" @selection-change="handleSelectionChange">
				<el-table-column type="selection" />
				<!-- 表头 -->
				<el-table-column label="学号" prop="id" width="auto" />
				<el-table-column label="姓名" prop="name" width="auto" />
				<el-table-column label="性别" prop="gender" width="auto" />
				<el-table-column label="学院" prop="faculty" width="auto" />
				<el-table-column label="专业" prop="major" width="auto" />
				<el-table-column label="班级" prop="class" width="auto" />
				<el-table-column label="在学课程" prop="course" width="300px">
					<template #default="scope">
						<el-button @click="getCourseList(scope.row)">列表</el-button>
						<el-button @click="addCourse(scope.row)">添加</el-button>
					</template>
				</el-table-column>
				<!-- 修改 -->
				<el-table-column fixed="right" label="操作" width=400px>
					<template #default="scope">
						<el-button type="primary" @click="modifyUser(scope.row)">编辑用户</el-button>
						<el-button type="warning" @click="resetPasswords(scope.row)">重置密码</el-button>
						<el-button type="danger" @click="removeUser(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 页面分页功能 -->
			<el-pagination :page-size="limit" :total="total" v-model:current-page="page" @click="fetchUserList" />
		</el-config-provider>

		<!-- 重置密码 -->
		<el-dialog v-model="resetVisible" title=" " width="50%" :show-close="false">
			<el-form :inline="true">
				<el-row style="justify-content: flex-end">
					<el-form-item>
						<el-button type="primary" @click="resetPassword">确定</el-button>
						<div>{{ message }}</div>
					</el-form-item>
				</el-row>
			</el-form>
		</el-dialog>
		<!-- 新建用户 -->
		<el-dialog title="输入信息" v-model="createDialogVisible" width="400px" :show-close="false">
			<el-form :model="createFormData">
				<el-form-item label="学号" prop="id" :rules="[
					{
						required: true,
						message: '请输入学号',
					},
				]">
					<el-input v-model="createFormData.id" placeholder="请输入学号"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="name" :rules="[
					{
						required: true,
						message: '请输入姓名',
					},
				]">
					<el-input v-model="createFormData.name" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password" :rules="[
					{
						required: true,
						message: '请输入密码',
					},
				]">
					<el-input v-model="createFormData.password" placeholder="请输入用户密码"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="gender">
					<el-select v-model="createFormData.gender" placeholder="请选择">
						<el-option label="男" value="男" />
						<el-option label="女" value="女" />
					</el-select>
				</el-form-item>
				<el-form-item label="学院" prop="faculty">
					<el-input v-model="createFormData.faculty" placeholder="请输入学院" />
				</el-form-item>
				<el-form-item label="专业" prop="major">
					<el-input v-model="createFormData.major" placeholder="请输入专业" />
				</el-form-item>
				<el-form-item label="班级" prop="class">
					<el-input v-model="createFormData.class" placeholder="请输入班级" />
				</el-form-item>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="createDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitCreateForm">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 删除用户 -->
		<el-dialog title="确认删除选中用户" v-model="removeBatchDialogVisible" width="400px" :show-close="false">
			<span class="dialog-footer">
				<el-button @click="removeBatchDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="batchRemove">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="确认删除" v-model="removeDialogVisible" width="400px" :show-close="false">
			<el-form class="dialog-information">
				<p class="dialog-information-text">
					确认删除该用户
				</p>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="removeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRemove">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑用户 -->
		<el-dialog title="编辑信息" v-model="modifyDialogVisible" width="400px" :show-close="false">
			<el-form :model="modifyFormData">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="modifyFormData.name" :placeholder="placeholder.namePlaceholder"></el-input>
				</el-form-item>

				<el-form-item label="性别" prop="gender">
					<el-select v-model="modifyFormData.gender" placeholder="请选择">
						<el-option label="男" value="男" />
						<el-option label="女" value="女" />
					</el-select>
				</el-form-item>
				<el-form-item label="学院" prop="faculty">
					<el-input v-model="modifyFormData.faculty" placeholder="请输入学院" />
				</el-form-item>
				<el-form-item label="专业" prop="major">
					<el-input v-model="modifyFormData.major" placeholder="请输入专业" />
				</el-form-item>
				<el-form-item label="班级" prop="class">
					<el-input v-model="modifyFormData.class" placeholder="请输入班级" />
				</el-form-item>

			</el-form>
			<span class="dialog-footer">
				<el-button @click="modifyDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitModifyForm">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="在学课程" v-model="courseDialogVisible" width="600px" :show-close="true">
			<!-- 课程表格 -->
			<el-table :data="courseList" style="width: 100%" highlight-current-row>
				<el-table-column label="课程号" prop="courseNum" :width="'auto'" />
				<el-table-column label="学期" prop="semester" :width="'auto'" />
				<el-table-column label="课程名称" prop="courseName" :width="'auto'" />
				<el-table-column label="结课状态" prop="closed" :formatter="formatClosed" :width="'auto'" />
			</el-table>
		</el-dialog>

		<el-dialog title="课程列表" v-model="addCourseDialogVisible" width="600px">
			<!-- Date Picker for selecting year -->
			<el-form>
				<el-date-picker v-model="filter.semester" type="year" placeholder="请选择开课年份" @change="updateFilter" />
				<el-form-item>
					<el-select v-model="addCourseForm.courseId" placeholder="请选择课程"
						style="width: 230px; margin-top: 20px; margin-left: auto; margin-right: auto; display: block;">
						<el-option v-for="course in classList" :key="course.id" :label="course.courseName"
							:value="course.id" />
					</el-select>
				</el-form-item>

			</el-form>
			<!-- Dialog footer with cancel and confirm buttons -->
			<span class="dialog-footer">
				<el-button @click="addCourseDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitAddCourseForm">确 定</el-button>
			</span>
		</el-dialog>


	</div>
</template>

<script>
import { defineComponent, ref, reactive, } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "@/styles/Common.css";
import * as XLSX from "xlsx";
import { ElNotification } from 'element-plus'

export default defineComponent({

	data() {
		return {
			userList: [],
			courseList: [],
			placeholder: {
				namePlaceholder: "请输入用户名",
			},
			selectRemoveId: "",
			removeBatchDialogVisible: false,
			removeDialogVisible: false,
			createDialogVisible: false,
			modifyDialogVisible: false,
			resetVisible: false,
			createFormData: {
				id: "",
				name: "",
				gender: "",
				faculty: "",
				major: "",
				class: "",
				password: "",
			},
			modifyFormData: {
				name: "",
				gender: "",
				faculty: "",
				major: "",
				class: "",
			},

			filterUser: {
				name: "",
				class: "",
				id: "",
			},
			page: 1,
			limit: 9,
			total: 0,

			// 学生在学课程列表
			courseDialogVisible: false,
			showAddCourse: false,

			addCourseForm: {
				userId: "",
				courseId: "",
			},

			// 添加课程
			addCourseDialogVisible: false,
			filter: {
				semester: "",
				dateStart: "",
				dateEnd: "",
			},
			classList: [],
			selectedCourse: null,

			// 文件上传学生信息
			course: {
				courseNum: "",
				semester: "",
				courseName: "",
			},
			users: [],

			interval: null,
			multipleSelection: [],
			batchRemoveDisabled: true,
			zhCn,
		};
	},
	// 刷新页面
	async mounted() {
		this.fetchUserList();
		this.interval = setInterval(() => {
			this.fetchUserList();
		}, 5000);
	},
	unmounted() {
		clearInterval(this.interval);
	},
	setup() {
		const multipleTableRef = ref(null);
		const currentId = ref(null);
		const fileInput = ref(null);
		return {
			multipleTableRef,
			currentId,
			fileInput,
		};
	},
	methods: {
		// 格式化 "结课状态" 字段
		formatClosed(row, column, cellValue) {
			return cellValue === 1 ? '已结课' : '未结课';
		},

		// 文件上传学生信息
		// 触发文件选择器
		triggerFileInput() {
			this.$refs.fileInput.click(); // 触发隐藏的文件输入框
		},

		// 文件选择后处理
		handleFileChange(event) {
			const file = event.target.files[0];
			if (!file) {
				alert("请选择一个文件！");
				return;
			}

			this.readFile(file)
				.then((sheetData) => {
					this.parseCourseInfo(sheetData);
					this.parseStudentInfo(sheetData);
				})
				.catch((err) => {
					console.error("文件解析失败:", err);
				});

			// 重置文件输入框，以便选择相同文件时能触发事件
			event.target.value = null;
		},

		// 读取文件内容
		readFile(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => {
					try {
						const data = new Uint8Array(e.target.result);
						const workbook = XLSX.read(data, { type: "array" });
						const sheet = workbook.Sheets[workbook.SheetNames[0]];
						const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
						resolve(sheetData);
					} catch (err) {
						reject(err);
					}
				};
				reader.onerror = (err) => reject(err);
				reader.readAsArrayBuffer(file);
			});
		},

		// 解析课程信息
		parseCourseInfo(sheetData) {
			this.course.semester = sheetData[0]?.[0]?.substring(0, 5) || "";
			this.course.courseNum = sheetData[1]?.[0]?.split("课程号：")[1]?.trim() || "";
			this.course.courseName = sheetData[1]?.[4]?.split("课程名称：")[1]?.trim() || "";
		},

		// 解析学生信息
		async parseStudentInfo(sheetData) {
			const studentData = sheetData.slice(6); // 从第7行开始
			this.users = studentData.map((row) => {
				return {
					id: row[1]?.toString().trim() || "",
					password: row[1]?.toString().trim() || "", // 学号作为密码
					name: row[2]?.toString().trim() || "",
					gender: row[3]?.toString().trim() || "",
					faculty: row[4]?.toString().trim() || "",
					major: row[5]?.toString().trim() || "",
					class: row[6]?.toString().trim() || "",
					course: { ...this.course }, // 嵌套课程信息
				};
			});
			console.log("学生列表", this.users)

			// 上传解析后的学生信息
			const postData = {
				users: this.users
			}
			try {
				const response = await this.$axios.post("/api/user/create", postData);
				if (response.code == '0') {
					ElNotification({
						title: '提示',
						message: '导入成功',
						type: 'success'
					});
				}
			} catch (error) {
				console.error("Error creating user:", error);
			}
		},

		// 表格背景
		rowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? "even-row" : "odd-row";
		},
		//获取表单
		async fetchUserList() {
			try {
				const response = await this.$axios.post("/api/user/list", {
					filter: this.filterUser,
					pageNum: this.page,
					pageLimit: this.limit,
				});

				this.userList = response.data.users; // 根据你的数据结构调整
				this.total = response.data.total;
			} catch (error) {
				console.error("An error occurred while fetching the dev list:", error);
			}
		},
		// 重置密码
		async resetPasswords(row) {
			let item = this.userList.find((item) => item.id === row.id);
			this.placeholder = {
				namePlaceholder: item.name,
			};
			this.resetVisible = true;
			this.currentId = row.id;
		},

		async resetPassword() {
			try {
				const postData = {
					id: this.currentId,
				};
				const response = await this.$axios.post("/api/user/reset", postData);
				console.log(response);
				this.resetVisible = false;
				this.fetchUserList();
			} catch (error) {
				console.error("Error removing user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 新增用户
		async submitCreateForm() {
			try {
				let users = []; // 初始化一个空数组
				// 向数组中添加一个新的对象
				users.push({
					id: this.createFormData.id,
					name: this.createFormData.name,
					gender: this.createFormData.gender,
					faculty: this.createFormData.faculty,
					major: this.createFormData.major,
					class: this.createFormData.class,
					password: this.createFormData.password,
				});
				const postData = reactive({
					users,
				});
				const response = await this.$axios.post("/api/user/create", postData);
				console.log("User created:", response.data);
				this.createFormData = {
					// 重置表单数据
					id: "",
					name: "",
					gender: "",
					faculty: "",
					major: "",
					class: "",
					password: "",
				};
				this.createDialogVisible = false;
				this.fetchUserList();
			} catch (error) {
				console.error("Error creating user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 编辑用户
		async modifyUser(row) {
			let item = this.userList.find((item) => item.id === row.id);

			this.modifyFormData = {
				id: item.id,
				name: item.name,
				gender: item.gender,
				faculty: item.faculty,
				major: item.major,
				class: item.class,
			};
			this.modifyDialogVisible = true;
			this.currentId = row.id;
		},
		async submitModifyForm() {
			try {
				const postData = {
					id: this.currentId,
					name: this.modifyFormData.name,
					password: this.modifyFormData.password,
					gender: this.modifyFormData.gender,
					faculty: this.modifyFormData.faculty,
					major: this.modifyFormData.major,
					class: this.modifyFormData.class,
				};

				const response = await this.$axios.post("/api/user/update", postData);
				this.modifyFormData = {
					// 重置表单数据
					name: "",
					gender: "",
					faculty: "",
					major: "",
					class: "",
				};

				console.log(response);
				this.modifyDialogVisible = false;
				this.placeholder = {
					namePlaceholder: "请输入用户名",
				};
				this.fetchUserList();
			} catch (error) {
				console.error("Error creating user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 删除用户
		async submitRemove() {
			try {
				const removeId = {
					ids: [this.selectRemoveId],
				};

				const response = await this.$axios.post("/api/user/remove", removeId);
				console.log("User removed:", response.data);

				console.log(response);
				this.removeDialogVisible = false;
				this.placeholder = {
					namePlaceholder: "请输入用户名",
				};
				this.fetchUserList();
			} catch (error) {
				console.error("Error removing user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 移除用户
		async removeUser(row) {
			let item = this.userList.find((item) => item.id === row.id);
			this.placeholder = {
				namePlaceholder: item.name,
			};
			this.selectRemoveId = row.id;
			this.removeDialogVisible = true;
		},
		async batchRemoveConfirm() {
			this.removeBatchDialogVisible = true;
		},
		async batchRemove() {
			const list = this.multipleSelection.map((item) => item.id);
			try {
				const removeId = {
					ids: list,
				};

				const response = await this.$axios.post("/api/user/remove", removeId);
				console.log("User removed:", response.data);
				this.removeBatchDialogVisible = false;
				this.fetchUserList();
			} catch (error) {
				console.error("Error removing user:", error);
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.batchRemoveDisabled =
				this.multipleSelection.length == 0 ? true : false;
			if (this.multipleSelection.length != 0) {
				clearInterval(this.interval);
			} else {
				this.interval = setInterval(() => {
					this.fetchUserList();
				}, 5000);
			}
			console.log(val);
		},

		// 获取学生的在学课程列表
		getCourseList(row) {
			let item = this.userList.find((item) => item.id === row.id);
			this.fetchCourseList(item.id);
		},

		async fetchCourseList(userId) {
			try {
				const response = await this.$axios.post("/api/user-course/list", {
					userId: userId,
				});
				this.courseList = response.data.courseList;
				console.log("Course list:", this.courseList);

				// 打开对话框，显示课程列表
				this.courseDialogVisible = true;
			} catch (error) {
				console.error("Error fetching course list:", error);
			}
		},

		// 添加课程
		addCourse(row) {
			let item = this.userList.find((item) => item.id === row.id);
			this.addCourseForm.userId = item.id;
			this.addCourseDialogVisible = true;
		},
		updateFilter() {
			if (this.filter.semester) {
				// 选择年份后更新 dateStart 和 dateEnd
				const year = this.filter.semester.getFullYear();  // 获取选择的年份

				// 设置 filter.dateStart 为该年份的 1月1日
				this.filter.dateStart = `${year}-01-01`;

				// 设置 filter.dateEnd 为该年份的 12月31日
				this.filter.dateEnd = `${year}-12-31`;

				console.log('更新后的日期范围:', this.filter.dateStart, this.filter.dateEnd);
			} else {
				// 如果没有选择年份，清空 dateStart 和 dateEnd
				this.filter.dateStart = '';
				this.filter.dateEnd = '';
			}
			this.fetchClassList();
		},
		//获取课程表单
		async fetchClassList() {
			try {
				const response = await this.$axios.post("/api/course/list", {
					dateStart: this.filter.dateStart,
					dateEnd: this.filter.dateEnd,
				});

				this.classList = response.data.courseList; // 根据你的数据结构调整
			} catch (error) {
				console.error("An error occurred while fetching the course list:", error);
			}
		},

		async submitAddCourseForm() {
			try {
				const response = await this.$axios.post("/api/user-course/create", this.addCourseForm);
				console.log("Course added:", response.data);
				this.addCourseDialogVisible = false;

				// 清理课程列表
				this.courseList = [];
				this.filter = {
					semester: null,
					dateStart: '',
					dateEnd: '',
				};
				this.selectedCourse = null;
				this.addCourseForm = {
					userId: '',
					courseId: '',
				}
			} catch (error) {
				console.error("Error adding course:", error);
			}
		}
	},
});
</script>

<style scoped>
:deep .even-row {
	background-color: #f0f0f0;
	/* 设置偶数行的背景色 */
}

:deep .odd-row {
	background-color: #ffffff;
	/* 设置奇数行的背景色 */
}

.button-group {
	display: flex;
	/* background-color: yellow; */
	height: 4vh;
}

.el-button {
	height: 100%;
	margin-right: 6px;
}

.el-pagination {
	margin-top: 1vh;
	position: absolute;
	bottom: 1vh;
}

.dialog-information {
	margin-bottom: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.dialog-information-text {
	margin: 10px;
	font-size: 15px;
}

:deep .el-dialog__header {
	margin-right: 0px;
}

:deep .el-dialog__body {
	padding-top: 16px;
}
</style>
